import Vue from "vue"

// Base Components
import JButton from "@/components/base/JButton"
import JCheckbox from "@/components/base/JCheckbox"
import JCheckboxGroup from "@/components/base/JCheckboxGroup"
import JDatePicker from "@/components/base/JDatePicker"
import JHtmlRenderer from "@/components/base/JHtmlRenderer"
import JInputDateOfBirth from "@/components/base/JInputDateOfBirth"
import JInputLongText from "@/components/base/JInputLongText"
import JInputNumber from "@/components/base/JInputNumber"
import JInputNumberStepper from "@/components/base/JInputNumberStepper"
import JInputText from "@/components/base/JInputText"
import JMessage from "@/components/base/JMessage"
import JRadios from "@/components/base/JRadios"
import JSelect from "@/components/base/JSelect"
import JSpinner from "@/components/base/JSpinner"
import JSlider from "@/components/base/JSlider"
import JToggle from "@/components/base/JToggle"
import JModalSimple from "@/components/base/JModalSimple"
import JMultiSelect from "@/components/base/JMultiSelect"
import JCalendar from "@/components/base/JCalendar"
import JBox from "@/components/base/JBox"
import JFlex from "@/components/base/JFlex"
import JText from "@/components/base/JText"
import JHeadline from "@/components/base/JHeadline"
import JLabel from "@/components/base/JLabel"

// Core
import CModal from "@/modules/core/components/CModal"
import CMessage from "@/modules/core/components/CMessage"
import CTable from "@/modules/core/components/CTable"
import CTableRow from "@/modules/core/components/CTableRow"
import CTableCell from "@/modules/core/components/CTableCell"
import CIcon from "@/modules/core/components/CIcon"
import CFormInput from "@/modules/core/components/CFormInput"
import CCodeEditor from "@/modules/core/components/CCodeEditor"
import CPopover from "@/modules/core/components/CPopover"
import CFilesExplorer from "@/modules/core/components/CFilesExplorer/"
import CFilesUpload from "@/modules/core/components/CFilesUpload"
import CGraphQlQueryLibrary from "@/modules/core/components/CGraphQlQueryLibrary/"
import CRichTextEditor from "@/modules/core/components/CRichTextEditor/"
import CLiquidPicker from "@/modules/core/components/CLiquidPicker/"
import CLayoutEditorHeader from "@/modules/core/components/CLayoutEditorHeader"
import CDialogProvider from "@/modules/core/components/CDialogProvider"

// Others
import ClientOnly from "@/components/base/ClientOnly"
import draggable from "vuedraggable"

// Register components globally
const baseComponents = {
	JButton,
	JCheckbox,
	JCheckboxGroup,
	JHtmlRenderer,
	JInputDateOfBirth,
	JInputLongText,
	JInputNumber,
	JInputNumberStepper,
	JInputText,
	JMessage,
	JRadios,
	JSelect,
	JSpinner,
	JSlider,
	JToggle,
	JModalSimple,
	JCalendar,
	JDatePicker,
	JMultiSelect,
	JBox,
	JFlex,
	JText,
	JHeadline,
	JLabel
}

const coreComponents = {
	CModal,
	CMessage,
	CTable,
	CTableRow,
	CTableCell,
	ClientOnly,
	CIcon,
	CFormInput,
	CCodeEditor,
	CPopover,
	CFilesExplorer,
	CFilesUpload,
	CGraphQlQueryLibrary,
	CRichTextEditor,
	CLiquidPicker,
	CLayoutEditorHeader,
	CDialogProvider
}

const components = { ...baseComponents, ...coreComponents }

export default () => {
	Object.keys(components).forEach(fileName => {
		const componentConfig = components[fileName]
		Vue.component(fileName, componentConfig.default || componentConfig)
	})

	Vue.component("JDraggable", draggable)
}
